import { Injectable } from '@angular/core';

import { Plan } from '../components/authentication/authentication-plans/plans.data';
import { StripePriceDto } from './payment.service';

@Injectable({ providedIn: 'root' })
export class PlanPricingService {
  applyPrices(plans: Plan[], prices: StripePriceDto[]): Plan[] {
    if (!Array.isArray(plans) || !Array.isArray(prices) || prices.length === 0) {
      return plans;
    }

    const priceById = new Map(prices.map((price) => [price.id, price]));
    const priceByProductId = new Map(
      prices.filter((price) => price.productId).map((price) => [price.productId as string, price])
    );
    const priceByProductName = new Map(
      prices
        .filter((price) => price.productName)
        .map((price) => [(price.productName as string).toLowerCase(), price])
    );

    return plans.map((plan) => {
      const stripePrice =
        (plan.stripePriceId && priceById.get(plan.stripePriceId)) ||
        (plan.stripeProductId && priceByProductId.get(plan.stripeProductId)) ||
        (plan.stripeProductName &&
          priceByProductName.get(plan.stripeProductName.toLowerCase())) ||
        priceByProductName.get(plan.title.toLowerCase());

      if (!stripePrice || typeof stripePrice.unitAmount !== 'number') {
        return plan;
      }

      if (stripePrice.recurringInterval && stripePrice.recurringInterval !== 'month') {
        console.warn(
          `Stripe Preis ${stripePrice.id} hat Intervall "${stripePrice.recurringInterval}". Erwartet wird "month".`
        );
        return plan;
      }

      const price = this.formatPrice(stripePrice.unitAmount, stripePrice.currency);
      const priceNote = this.buildPriceNote(plan.priceNote, stripePrice);

      return {
        ...plan,
        price,
        priceNote,
      };
    });
  }

  private formatPrice(amountInMinorUnits: number, currency: string): string {
    const amount = amountInMinorUnits / 100;

    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency?.toUpperCase?.() || 'EUR',
        minimumFractionDigits: 2,
      }).format(amount);
    } catch (error) {
      console.warn('Preisformatierung fehlgeschlagen, fallback wird genutzt.', error);
      const safeCurrency = currency ? currency.toUpperCase() : 'EUR';
      return `${amount.toFixed(2)} ${safeCurrency}`;
    }
  }

  private buildPriceNote(existingNote: string | undefined, price?: StripePriceDto): string | undefined {
    if (price?.nickname) {
      return price.nickname;
    }

    if (existingNote?.startsWith('pro Mitglied/')) {
      return 'pro Mitglied/Monat';
    }

    if (existingNote) {
      return existingNote;
    }

    return 'pro Monat';
  }

}
